<div class="burger clickable" (click)="open()">
  <svg height="32px" id="Layer_1" style="enable-background:new 0 0 32 32;" version="1.1" viewBox="0 0 32 32"
    width="32px" xml:space="preserve">
    <path fill="white"
      d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z" />
  </svg>
</div>

<div class="side-options-container container-fluid card p-2" [ngClass]="{opened: opened}">
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>

  <h2>Historial del Paciente</h2>
  <div class="card-body" style="overflow: auto;">
    <div class="row g-0 history-entry align-items-center p-2">
      <span>02/04/2020 - Resonancia Magnética de Hombro</span>
    </div>
    <div class="row g-0 history-entry align-items-center p-2">
      <span>02/04/2020 - Resonancia Magnética de Hombro</span>
    </div>
    <div class="row g-0 history-entry align-items-center p-2">
      <span>02/04/2020 - Resonancia Magnética de Hombro</span>
    </div>
    <div class="row g-0 history-entry align-items-center p-2">
      <span>02/04/2020 - Resonancia Magnética de Hombro</span>
    </div>
    <div class="row g-0 history-entry align-items-center p-2">
      <span>02/04/2020 - Resonancia Magnética de Hombro</span>
    </div>
    <div class="row g-0 history-entry align-items-center p-2">
      <span>02/04/2020 - Resonancia Magnética de Hombro</span>
    </div>
    <div class="row g-0 history-entry align-items-center p-2">
      <span>02/04/2020 - Resonancia Magnética de Hombro</span>
    </div>
    <div class="row g-0 history-entry align-items-center p-2">
      <span>02/04/2020 - Resonancia Magnética de Hombro</span>
    </div>
    <div class="row g-0 history-entry align-items-center p-2">
      <span>02/04/2020 - Resonancia Magnética de Hombro</span>
    </div>
    <div class="row g-0 history-entry align-items-center p-2">
      <span>02/04/2020 - Resonancia Magnética de Hombro</span>
    </div>
    <div class="row g-0 history-entry align-items-center p-2">
      <span>02/04/2020 - Resonancia Magnética de Hombro</span>
    </div>
  </div>

  <button type="button" class="card bottom-button download">
    <span>Descargar</span>
  </button>

  <button type="button" class="card bottom-button share">
    <span>Compartir</span>
  </button>
</div>